import { useWatch } from 'react-hook-form';
import { NumberInput } from 'shared/components';
import { MassActionSelection } from 'shared/types';

const priceComponentMap: Record<MassActionSelection['type'], JSX.Element> = {
  override: (
    <NumberInput
      name='amount'
      label='Override to Set'
      prefix='$'
      rules={{
        required: {
          message: 'Override is required!',
          value: true,
        },
      }}
    />
  ),
  percentage: (
    <NumberInput
      name='amount'
      label='Percentage to Set'
      suffix='%'
      rules={{
        required: {
          message: 'Percentage is required',
          value: true,
        },
      }}
    />
  ),
  adder: (
    <NumberInput
      name='amount'
      label='Adder to Set'
      prefix='$'
      rules={{
        required: {
          message: 'Adder is required!',
          value: true,
        },
      }}
    />
  ),
};

export function DynamicPriceFields() {
  const selection: MassActionSelection = useWatch({ name: 'type' });
  if (!selection) return null;
  const component = priceComponentMap[selection.type];
  return component;
}
